import UserConstants from '../constants/UserConstants';
import preferences from '../Preferences';
import {DEFAULT_LANGUAGE_TAG} from './LanguageTagConstants';

const {LANGUAGE_PREFERENCE_KEY} = UserConstants;

// Attempts to get the current user's general language preference key before defaulting to
//  the default language tag.
export const safelyGetUserLocale = (): string =>
  preferences.get(LANGUAGE_PREFERENCE_KEY) ?? DEFAULT_LANGUAGE_TAG.code;
